import { render, staticRenderFns } from "./LeftHandedIcon.vue?vue&type=template&id=60a59cba&scoped=true"
import script from "./LeftHandedIcon.vue?vue&type=script&lang=js"
export * from "./LeftHandedIcon.vue?vue&type=script&lang=js"
import style0 from "./LeftHandedIcon.vue?vue&type=style&index=0&id=60a59cba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a59cba",
  null
  
)

export default component.exports